import React, { useState } from "react";
import { TodaysGames, LiveGames } from "../Data";
import { NflTodaySchedule, NflWeeklySchedule } from './nfl.js/NflSchedule.jsx';
import { NbaTodaySchedule, NbaWeeklySchedule } from './nba.js/NbaSchedule.jsx';
import { useTheme } from './theme/ThemeContext.jsx';
import NhlPlayoffsHub from './NhlPlayoffsHub.jsx';
import playoffsNHL from "./buttonImages/playoffsNHL.webp";
import SeasonalCardToggle from "./theme/SeasonalCardToggle.jsx";


function Matches() {
  const { theme, seasonalCardsEnabled } = useTheme();
  const [showPlayoffs, setShowPlayoffs] = useState(false);

  const containerStyle = {
    backgroundColor:
      theme === "light"
        ? "#E0E0E0" // Light theme background
        : theme === "dark"
        ? "#1E1E1E" // Dark theme background
        : "transparent", // Transparent for retro theme (gradient will handle the background)
    background:
      theme === "retro"
        ? "linear-gradient(to bottom, #0B1305 0%, #00008B 100%)" // Retro theme gradient
        : theme === "light"
        ? "#E0E0E0" // Light theme background
        : "#1E1E1E", // Dark theme background
    color: theme === "light" ? "#000000" : "#FFFFFF", // Text color
    borderRadius: "5px",
    padding: "20px",
  };

  const hrStyle = {
    backgroundColor: theme === "light" ? "#000000" : "#FFFFFF", 
    height: "2px",
  };

  if (showPlayoffs) {
    return (
      <div className="container text-center p-2" style={containerStyle}>
        <button
          type="button"
          className="fb-btn fb-btn--ghost mb-3"
          onClick={() => setShowPlayoffs(false)}
        >
          ← Back to Schedule
        </button>
        <NhlPlayoffsHub />
      </div>
    );
  }

  return (
    <div
      className={`container text-center p-2 seasonal-card-toggle-anchor ${seasonalCardsEnabled ? "seasonal-card-theme-enabled" : ""}`}
      style={containerStyle}
    >
      <SeasonalCardToggle />
      <button
        type="button"
        className="fb-btn fb-btn--primary d-flex align-items-center justify-content-center gap-2 mx-auto mb-3"
        onClick={() => setShowPlayoffs(true)}
      >
        <img
          src={playoffsNHL}
          alt=""
          style={{ width: 28, height: 28, objectFit: "contain", borderRadius: 4 }}
        />
        Stanley Cup Playoffs
      </button>
      <LiveGames />
      <hr style={hrStyle} />
      <TodaysGames />
    </div>
  );
}



function NflMatches() {
  const { theme, seasonalCardsEnabled } = useTheme();

  const containerStyle = {
    backgroundColor:
      theme === "light"
        ? "#E0E0E0" 
        : theme === "dark"
        ? "#1E1E1E" 
        : "transparent", 
    background:
      theme === "retro"
        ? "linear-gradient(to bottom, #0B1305 0%, #00008B 100%)"
        : "none",
    color: theme === "light" ? "#000000" : "#FFFFFF",
    borderRadius: "1rem",
    padding: "20px",
  };

  return (
    <div style={containerStyle} className={`container text-center p-2 seasonal-card-toggle-anchor ${seasonalCardsEnabled ? "seasonal-card-theme-enabled" : ""}`}>
      <SeasonalCardToggle />
      {<NflTodaySchedule />}
      {<NflWeeklySchedule />}
    </div>
  );
}

function NbaMatches() {
  const { theme, seasonalCardsEnabled } = useTheme();

  const containerStyle = {
    backgroundColor:
      theme === "light"
        ? "#E0E0E0"
        : theme === "dark"
        ? "#1E1E1E"
        : "transparent",
    background:
      theme === "retro"
        ? "linear-gradient(to bottom, #0B1305 0%, #00008B 100%)"
        : "none",
    color: theme === "light" ? "#000000" : "#FFFFFF",
    borderRadius: "1rem",
    padding: "20px",
  };

  return (
    <div style={containerStyle} className={`container text-center p-2 seasonal-card-toggle-anchor ${seasonalCardsEnabled ? "seasonal-card-theme-enabled" : ""}`}>
      <SeasonalCardToggle />
      {<NbaTodaySchedule />}
      {<NbaWeeklySchedule />}
    </div>
  );
}
export { Matches, NflMatches, NbaMatches };
